module.exports = __webpack_public_path__ + "static/media/TP18.eb40fc5c.jpg";